import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocalStorageService } from '../appServices/localstorage/localstorage.service';

export const authGuard: CanActivateFn = (route, state) => {
  const localStorageService = inject(LocalStorageService);
  const router = inject(Router);
  
  const token = localStorageService.getItem('token') ?? '';

  if (token) {
    return true;
  }
  router.navigate(['/']);
  return false;
};
